import axios from 'axios';

export const getDropdownSubCategory = async () => {
    return await axios.get(`${window._HOST}admin/akun/subCategories/dropdown`, {withCredentials: true});
}

export const getAllDataTableAkunSubKategori = async (searchText = null, offset = 0, limit = 0, sortingCol = 0, sortingMode = 'DESC') => {
    if(searchText) {
        return await axios.get(`${window._HOST}admin/akun/subCategories/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    } else {
        return await axios.get(`${window._HOST}admin/akun/subCategories/dataTable?offset=${offset}&${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    }
}

export const insertNewAkunSubKategori = async (formData) => {
    return await axios.post(`${window._HOST}admin/akun/subCategories`, formData, {withCredentials: true})
}

export const updateAkunSubKategori = async (formData, id_akun_sub_kategori) => {
    return await axios.put(`${window._HOST}admin/akun/subCategories/${id_akun_sub_kategori}`, formData, {withCredentials: true});
}

export const deleteAkunSubKategori = async (id_akun_sub_kategori) => {
    return await axios.delete(`${window._HOST}admin/akun/subCategories/${id_akun_sub_kategori}`, {withCredentials: true})
}